module.exports = __webpack_public_path__ + "static/media/intagram.2d9aea33.svg";